module.exports = __webpack_public_path__ + "static/img/装饰11.e6c6654.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰11.svg
// module id = 6TXd
// module chunks = 2